<!-- Sidebar -->
<div class="drawer lg:drawer-open">
  <input id="drawer-toggle" type="checkbox" class="drawer-toggle" />

  <div class="drawer-content flex flex-col">
    <!-- Top bar móvil -->
    <div class="navbar h-16 min-h-[64px] bg-base-100 shadow-sm border-b border-base-300 lg:hidden">
      <div class="flex-none">
        <label for="drawer-toggle" class="btn btn-square btn-ghost">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            class="inline-block w-5 h-5 stroke-current"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16"
            ></path>
          </svg>
        </label>
      </div>

      <div class="flex-1">
        <a routerLink="/" class="btn btn-ghost">
          <img src="/img/coloclick.png" alt="ColoClic" class="h-8 w-auto" />
        </a>
      </div>

      <div class="flex-none">
        @if (authStatus() === 'authenticated') { @if (user(); as currentUser) {
        <div class="dropdown dropdown-end">
          <div tabindex="0" role="button" class="btn btn-ghost btn-circle avatar">
            <div
              class="w-8 rounded-full bg-primary text-white flex items-center justify-center font-semibold text-xs"
            >
              {{ ((currentUser.name || currentUser.username || 'U')[0] || 'U').toUpperCase() }}
            </div>
          </div>

          <ul
            tabindex="0"
            class="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52"
          >
            <li class="menu-title">
              <span>{{ currentUser.name || 'Usuario' }}</span>
            </li>
            <li class="menu-title">
              <span class="text-xs text-base-content/70">{{ currentUser.username || '' }}</span>
            </li>
            <li><div class="divider my-1"></div></li>
            <li>
              <button type="button" (click)="onLogout()" class="text-error w-full text-left">
                Cerrar Sesión
              </button>
            </li>
          </ul>
        </div>
        } @else {
        <a routerLink="/auth/login" class="btn btn-primary btn-sm text-white"> Iniciar Sesión </a>
        } }
      </div>
    </div>

    <!-- Top bar desktop (Minimal - Only User Menu) -->
    <div class="navbar h-16 min-h-[64px] bg-base-100 shadow-sm border-b border-base-300 hidden lg:flex justify-end px-4">
      <div class="flex-none">
        @if (authStatus() === 'authenticated') { @if (user(); as currentUser) {
        <div class="dropdown dropdown-end">
          <div tabindex="0" role="button" class="btn btn-ghost btn-circle avatar">
            <div
              class="w-10 rounded-full bg-primary text-white flex items-center justify-center font-semibold"
            >
              {{ ((currentUser.name || currentUser.username || 'U')[0] || 'U').toUpperCase() }}
            </div>
          </div>

          <ul
            tabindex="0"
            class="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52"
          >
            <li class="menu-title">
              <span>{{ currentUser.name || 'Usuario' }}</span>
            </li>
            <li class="menu-title">
              <span class="text-xs text-base-content/70">{{ currentUser.username || '' }}</span>
            </li>
            <li><div class="divider my-1"></div></li>
            <li>
              <button type="button" (click)="onLogout()" class="text-error w-full text-left">
                Cerrar Sesión
              </button>
            </li>
          </ul>
        </div>
        } @else {
        <a routerLink="/auth/login" class="btn btn-primary btn-sm text-white"> Iniciar Sesión </a>
        } }
      </div>
    </div>

    <!-- Content area -->
    <ng-content></ng-content>
  </div>

  <!-- Sidebar -->
  <div class="drawer-side">
    <label for="drawer-toggle" class="drawer-overlay lg:hidden" aria-label="close sidebar"></label>
    <aside class="w-64 min-h-full bg-base-200 text-base-content">
      <!-- Logo -->
      <div class="h-16 min-h-[64px] px-4 flex items-center justify-center border-b border-base-300">
        <a routerLink="/" class="flex items-center justify-center">
          <img src="/img/coloclick.png" alt="ColoClic" class="h-9 w-auto object-contain" />
        </a>
      </div>

      <!-- Menu -->
      <ul class="menu p-4 w-full text-base-content">
        <li>
          <a
            routerLink="/"
            routerLinkActive="active bg-primary text-white"
            [routerLinkActiveOptions]="{ exact: true }"
            class="flex items-center gap-3"
            (click)="closeDrawer()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
              />
            </svg>
            Inicio
          </a>
        </li>

        @if (authStatus() === 'authenticated') {

        <!-- Módulo Administrativo -->
        @if (hasAdministrativoModule()) {
        <li>
          <details>
            <summary class="flex items-center gap-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
              Administrativo
            </summary>
            <ul class="ml-4 mt-1">
              @if (canViewInsureds()) {
              <li><a routerLink="/insureds" routerLinkActive="active" (click)="closeDrawer()">Consulta de Asegurados</a></li>
              }
            </ul>
          </details>
        </li>
        }

        <!-- Módulo Cobros -->
        @if (hasCobrosModule()) {
        <li>
          <details>
            <summary class="flex items-center gap-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                />
              </svg>
              Cobros
            </summary>
            <ul class="ml-4 mt-1">
              <li><a routerLink="/payments/reports" routerLinkActive="active" (click)="closeDrawer()">Reportes</a></li>
            </ul>
          </details>
        </li>
        }

        <!-- Módulo Consulta -->
        @if (hasConsultaModule()) {
        <li>
          <details>
            <summary class="flex items-center gap-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
              Consulta
            </summary>
            <ul class="ml-4 mt-1">
              @if (canViewClients()) {
              <li><a routerLink="/clients" routerLinkActive="active" (click)="closeDrawer()">Consulta de Clientes</a></li>
              }
            </ul>
          </details>
        </li>
        }

        <!-- Módulo Cotizaciones -->
        @if (hasCotizacionesModule()) {
        <li>
          <details>
            <summary class="flex items-center gap-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              Cotizaciones
            </summary>
            <ul class="ml-4 mt-1">
              @if (canCotizarArmaloTu()) {
              <li>
                <a
                  routerLink="/quotes/armalo-tu"
                  routerLinkActive="active bg-primary text-white"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="closeDrawer()"
                  >Ármalo tú</a
                >
              </li>
              }
              @if (canCotizarAuto()) {
              <li>
                <a
                  routerLink="/quotes"
                  routerLinkActive="active bg-primary text-white"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="closeDrawer()"
                  >Auto</a
                >
              </li>
              }
              @if (canDescuentoArmaloTu()) {
              <li>
                <a
                  routerLink="/quotes/descuento-armalo-tu"
                  routerLinkActive="active bg-primary text-white"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="closeDrawer()"
                  >Descuento Ármalo tú</a
                >
              </li>
              }
              @if (canEmprendeSeguro()) {
              <li>
                <a
                  routerLink="/quotes/emprende-seguro"
                  routerLinkActive="active bg-primary text-white"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="closeDrawer()"
                  >Emprende Seguro</a
                >
              </li>
              }
              @if (canHogarSeguro()) {
              <li>
                <a
                  routerLink="/quotes/hogar-seguro"
                  routerLinkActive="active bg-primary text-white"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="closeDrawer()"
                  >Hogar Seguro</a
                >
              </li>
              }
              <li>
                <a
                  [href]="personasUrl"
                  target="_blank"
                  (click)="closeDrawer()"
                  >Personas</a
                >
              </li>
              <li>
                <a
                  [href]="riesgosUrl"
                  target="_blank"
                  (click)="closeDrawer()"
                  >Riesgos</a
                >
              </li>
              @if (canCotizarSmi()) {
              <li>
                <a
                  [href]="smiUrl"
                  target="_blank"
                  (click)="closeDrawer()"
                  >SMI</a
                >
              </li>
              }
            </ul>
          </details>
        </li>
        }

        <!-- Módulo Estadísticas -->
        @if (hasEstadisticasModule()) {
        <li>
          <details>
            <summary class="flex items-center gap-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                />
              </svg>
              Estadísticas
            </summary>
            <ul class="ml-4 mt-1">
              @if (canViewBondGrowth()) {
              <li><a routerLink="/statistics/bond-growth" routerLinkActive="active" (click)="closeDrawer()" class="whitespace-normal leading-snug py-2">Primas Cobradas Bono Crecimiento</a></li>
              }
              @if (canViewStatisticsReports()) {
              <li><a routerLink="/statistics/reports" routerLinkActive="active" (click)="closeDrawer()">Reportes</a></li>
              }
            </ul>
          </details>
        </li>
        }

        <!-- Módulo Mantenimiento -->
        @if (hasMantenimientoModule()) {
        <li>
          <details>
            <summary class="flex items-center gap-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                />
              </svg>
              Mantenimiento
            </summary>
            <ul class="ml-4 mt-1">
              @if (canSafeSurgery()) {
              <li><a routerLink="/safe-surgery" routerLinkActive="active" (click)="closeDrawer()">Cirugía Segura</a></li>
              }
              <!-- Ocultado temporalmente; descomentar si se requiere en el futuro
              @if (canViewMyUsers()) {
              <li><a routerLink="/users" routerLinkActive="active" (click)="closeDrawer()">Mis Usuarios</a></li>
              }
              -->
            </ul>
          </details>
        </li>
        }

        <!-- Módulo Pagos -->
        @if (hasPagosModule()) {
        <li>
          <details>
            <summary class="flex items-center gap-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 10h18M7 15h1m4 0h1m-7 4h12a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
              Pagos
            </summary>
            <ul class="ml-4 mt-1">
              @if (canCreditCardPayment()) {
              <li><a routerLink="/payments/credit-card-payment" routerLinkActive="active" (click)="closeDrawer()" class="whitespace-normal leading-snug py-2">Pagos Tarjetas de Crédito</a></li>
              }
              @if (canReprintCardReceipts()) {
              <li><a routerLink="/payments/reprint-credit-card-receipts" routerLinkActive="active" (click)="closeDrawer()" class="whitespace-normal leading-snug py-2">Reimpresión Recibos Tarjeta de Crédito</a></li>
              }
            </ul>
          </details>
        </li>
        }

        <!-- Módulo Pólizas -->
        @if (hasPolizasModule()) {
        <li>
          <details>
            <summary class="flex items-center gap-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                />
              </svg>
              Pólizas
            </summary>
            <ul class="ml-4 mt-1">
              @if (canViewPoliciesReports()) {
              <li><a routerLink="/policies/reports" routerLinkActive="active" (click)="closeDrawer()">Reportes</a></li>
              }
            </ul>
          </details>
        </li>
        }

        <!-- Módulo Reclamaciones -->
        @if (hasReclamacionesModule()) {
        <li>
          <details>
            <summary class="flex items-center gap-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 012-2h2a2 2 0 012 2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                />
              </svg>
              Reclamaciones
            </summary>
            <ul class="ml-4 mt-1">
              @if (canViewMyClaims()) {
              <li><a routerLink="/claims/my-claims" routerLinkActive="active bg-primary text-white" (click)="closeDrawer()">Mis Reclamaciones</a></li>
              }
            </ul>
          </details>
        </li>
        }

        <!-- Módulo Reporte -->
        @if (hasReporteModule()) {
        <li>
          <details>
            <summary class="flex items-center gap-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              Reporte
            </summary>
            <ul class="ml-4 mt-1">
              @if (canViewLossRatio()) {
              <li><a routerLink="/statistics/loss-ratio" routerLinkActive="active" (click)="closeDrawer()">Reporte de Siniestralidad</a></li>
              }
            </ul>
          </details>
        </li>
        }
        }
      </ul>
    </aside>
  </div>
</div>
